import { getItemFields } from '@cheqroom/api';
import { selectFieldDefs } from '@cheqroom/components';
import { useMemo } from 'react';

import { useItemTypeCustomFields } from '../custom-fields/use-custom-fields.hook';
import { useSettings } from '../settings/use-settings.hook';

export const useItemInfoFieldDefs = (itemTypeId: string | undefined, fieldIds: string[]) => {
	const customFields = useItemTypeCustomFields({ itemTypeId });
	const { currency } = useSettings();

	return useMemo(() => {
		const allFieldDefs = getItemFields({ customFields, currency }).filter((field) => field.id !== 'isRestricted');
		return selectFieldDefs(allFieldDefs, fieldIds);
	}, [customFields, currency, fieldIds]);
};
